module.exports = __webpack_public_path__ + "static/img/technologyu01.118491b1.png";